<template>
  <div class="content-wrapper d-lg-block" :class="{'d-none': isMobileMenuOpen}">
    <mobile-top @close-mobile-menu="close_mobile_menu"></mobile-top>

    <p class="text-center m-5 slack">
      <a :href="slack_workspace_url" target="_blank"><i class="fab fa-slack"></i></a>
      <br>
      {{ $t('layouts.default.open_slack') }}
    </p>
    <div class="slack-dynamic-content text-center"
         v-for="dynamic_content in slack_dynamic_contents"
         v-bind:key="dynamic_content.id"
    >
      <h4>{{ dynamic_content.title }}</h4>
      <div v-html="dynamic_content.content"></div>
      <img v-if="dynamic_content.image_url"
           :src="dynamic_content.image_url"
           class="img-fluid"
           alt="content"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import MobileTop from './MobileTop.vue'

export default {
  props: ['isMobileMenuOpen'],
  data () {
    return {
      slack_workspace_url: process.env.VUE_APP_SLACK_WORKSPACE_URL
    }
  },
  components: {
    MobileTop
  },
  computed: {
    ...mapState({
      user_theme: state => state.user_theme.user_theme
    }),
    ...mapGetters({
      slack_dynamic_contents: 'dynamic_contents/slack_dynamic_contents'
    })
  },
  methods: {
    close_mobile_menu () {
      this.$emit('close-mobile-menu')
    }
  }
}
</script>

<style scoped lang="scss">
</style>
